import { render, staticRenderFns } from "./EditLiveAddWaypointForm.vue?vue&type=template&id=2b1df3f2"
import script from "./EditLiveAddWaypointForm.vue?vue&type=script&lang=js"
export * from "./EditLiveAddWaypointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports